import { AnimatedSection } from '@denqfabrik/landing-ui';
import { useTranslation } from '../../i18n';

export default function WhyAletiqSection() {
  const { t } = useTranslation();
  const { label, heading, headingHighlight, cards } = t.whyAletiq;

  return (
    <section id="why-aletiq" data-nav-theme="light" className="bg-[#f2f5fa] py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <AnimatedSection>
          <div className="mx-auto mb-14 max-w-3xl text-center">
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-teal-500">
              {label}
            </p>
            <h2 className="font-display text-4xl font-bold tracking-tight text-slate-900 md:text-5xl lg:text-6xl">
              {heading}{' '}
              <span className="bg-gradient-to-r from-sky-400 to-blue-500 bg-clip-text text-transparent">
                {headingHighlight}
              </span>
            </h2>
          </div>
        </AnimatedSection>

        {/* Cards */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          {cards.map((card, i) => (
            <AnimatedSection key={card.title} delay={i * 120}>
              <div className="flex h-full flex-col rounded-[18px] border border-[#dce2eb] bg-white p-5 shadow-sm transition-shadow hover:shadow-md sm:p-8">
                <span className="mb-5 text-4xl">{card.icon}</span>
                <h3 className="mb-3 text-xl font-bold text-slate-900">{card.title}</h3>
                <p className="text-[0.94rem] leading-relaxed text-slate-600">{card.description}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
